import { render } from "./DisparadorNotificacionesRegistro.vue?vue&type=template&id=07f9ee3c"
import script from "./DisparadorNotificacionesRegistro.vue?vue&type=script&lang=js"
export * from "./DisparadorNotificacionesRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__